/* eslint-disable indent */
import { getAuth } from 'firebase/auth';
import { app } from '../configs/firebaseApp';
import { ManualVerificationSession } from '../redux/manualVerification/sessionsDetails/types';
import { UserType } from '../redux/user';

export function exxtractCommaSeparatedList(list: string) {
  const parsedValues = list.trim().split(',');

  // Remove empty strings from the array
  const filteredValues = parsedValues
    .map((value) => value.trim())
    .filter((value: string) => {
      return value.trim() !== '';
    });

  return filteredValues;
}

export async function getFirebaseIdToken() {
  const auth = getAuth(app);
  const token = await auth.currentUser?.getIdToken();
  return token;
}

export function isAdmin(userType?: string) {
  return userType === UserType.ADMIN;
}

export const getApiUrl = () => {
  const environment = process.env.REACT_APP_ENV;

  switch (environment) {
    case 'production':
      return process.env.REACT_APP_BACKEND_URL || 'https://api.reclaimprotocol.org';

    case 'development':
      return process.env.REACT_APP_LOCAL_BACKEND_URL || 'http://localhost:3003';
    default:
      return 'http://localhost:3003';
  }
};

export const getBlueCheckApiUrl = () => {
  const environment = process.env.REACT_APP_ENV;

  switch (environment) {
    case 'production':
      return (
        'https://api.thebluecheck.com/api/v1/production'
      );

    case 'development':
      return (
        'https://api.thebluecheck.com/api/v1/production'
      );
    default:
      return 'http://localhost:3000/api/v1/development';
  }
};

export const sortByCreatedAtDesc = (
  array: ManualVerificationSession[] | any[]
): ManualVerificationSession[] | any[] => {
  return array.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};
